
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as productxm598kh8CCDtW3rqBXaCXfYbZrp0W2zHUfqRuG6bb10Meta } from "/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product.vue?macro=true";
export default [
  {
    name: "explore-by-need-choose-a-proportionate-path-to-workable-capability",
    path: "/explore-by-need/choose-a-proportionate-path-to-workable-capability",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/explore-by-need/choose-a-proportionate-path-to-workable-capability.vue")
  },
  {
    name: "explore-by-need-paper-to-digital-quality-transformation",
    path: "/explore-by-need/paper-to-digital-quality-transformation",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/explore-by-need/paper-to-digital-quality-transformation.vue")
  },
  {
    name: "explore-by-need-quality-process-mapping-development-and-implementation",
    path: "/explore-by-need/quality-process-mapping-development-and-implementation",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/explore-by-need/quality-process-mapping-development-and-implementation.vue")
  },
  {
    name: "explore-by-need-software-implementation-maintenance-and-management",
    path: "/explore-by-need/software-implementation-maintenance-and-management",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/explore-by-need/software-implementation-maintenance-and-management.vue")
  },
  {
    name: "explore-by-need-validate-excel-quality-register",
    path: "/explore-by-need/validate-excel-quality-register",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/explore-by-need/validate-excel-quality-register.vue")
  },
  {
    name: "services-paper-to-digital-quality-transformation",
    path: "/services/paper-to-digital-quality-transformation",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/services/paper-to-digital-quality-transformation.vue")
  },
  {
    name: "services-quality-process-mapping-development-and-implementation",
    path: "/services/quality-process-mapping-development-and-implementation",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/services/quality-process-mapping-development-and-implementation.vue")
  },
  {
    name: "services-software-implementation-maintenance-and-management",
    path: "/services/software-implementation-maintenance-and-management",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/services/software-implementation-maintenance-and-management.vue")
  },
  {
    name: "solutions-excel-register-to-sharepoint",
    path: "/solutions/excel-register-to-sharepoint",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/solutions/excel-register-to-sharepoint.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/blog/[slug].vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/404.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/about.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/blog/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/contact/index.vue")
  },
  {
    name: "explore-by-need",
    path: "/explore-by-need",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/explore-by-need/index.vue")
  },
  {
    name: "industries",
    path: "/industries",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/industries.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/privacy.vue")
  },
  {
    name: productxm598kh8CCDtW3rqBXaCXfYbZrp0W2zHUfqRuG6bb10Meta?.name,
    path: "/product",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product.vue"),
    children: [
  {
    name: "product-agentic-ai-governance",
    path: "agentic-ai-governance",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/agentic-ai-governance.vue")
  },
  {
    name: "product-choosing-ai-use-cases-for-gmp-quality-work",
    path: "choosing-ai-use-cases-for-gmp-quality-work",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/choosing-ai-use-cases-for-gmp-quality-work.vue")
  },
  {
    name: "product-controlled-change-for-gmp-ai-workflows",
    path: "controlled-change-for-gmp-ai-workflows",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/controlled-change-for-gmp-ai-workflows.vue")
  },
  {
    name: "product-data-and-system-governance-for-quality-teams",
    path: "data-and-system-governance-for-quality-teams",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/data-and-system-governance-for-quality-teams.vue")
  },
  {
    name: "product-defining-gmp-boundary-for-ai-outputs",
    path: "defining-gmp-boundary-for-ai-outputs",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/defining-gmp-boundary-for-ai-outputs.vue")
  },
  {
    name: "product-designing-responsibilities-and-feedback-loops-for-repeatable-quality-practice",
    path: "designing-responsibilities-and-feedback-loops-for-repeatable-quality-practice",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/designing-responsibilities-and-feedback-loops-for-repeatable-quality-practice.vue")
  },
  {
    name: "product-evaluating-gmp-ai-before-and-after-release",
    path: "evaluating-gmp-ai-before-and-after-release",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/evaluating-gmp-ai-before-and-after-release.vue")
  },
  {
    name: "product-evidence-and-traceability-for-gmp-ai",
    path: "evidence-and-traceability-for-gmp-ai",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/evidence-and-traceability-for-gmp-ai.vue")
  },
  {
    name: "product-human-oversight-for-gmp-ai-workflows",
    path: "human-oversight-for-gmp-ai-workflows",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/human-oversight-for-gmp-ai-workflows.vue")
  },
  {
    name: "product-improving-flow-without-weakening-control",
    path: "improving-flow-without-weakening-control",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/improving-flow-without-weakening-control.vue")
  },
  {
    name: "product-iso-9001",
    path: "iso-9001",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/iso-9001.vue")
  },
  {
    name: "product-iso-9001-readiness-planning",
    path: "iso-9001-readiness-planning",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/iso-9001-readiness-planning.vue")
  },
  {
    name: "product-iso-9001-records-and-management-review",
    path: "iso-9001-records-and-management-review",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/iso-9001-records-and-management-review.vue")
  },
  {
    name: "product-mapping-where-quality-problems-are-created-across-a-system",
    path: "mapping-where-quality-problems-are-created-across-a-system",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/mapping-where-quality-problems-are-created-across-a-system.vue")
  },
  {
    name: "product-ongoing-control-beyond-validation",
    path: "ongoing-control-beyond-validation",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/ongoing-control-beyond-validation.vue")
  },
  {
    name: "product-procedures-and-work-instructions-alignment",
    path: "procedures-and-work-instructions-alignment",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/procedures-and-work-instructions-alignment.vue")
  },
  {
    name: "product-quality-dashboards",
    path: "quality-dashboards",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/quality-dashboards.vue")
  },
  {
    name: "product-quality-system-implementation-capacity",
    path: "quality-system-implementation-capacity",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/quality-system-implementation-capacity.vue")
  },
  {
    name: "product-quality-systems",
    path: "quality-systems",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/quality-systems.vue")
  },
  {
    name: "product-reducing-quality-system-administration",
    path: "reducing-quality-system-administration",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/reducing-quality-system-administration.vue")
  },
  {
    name: "product-regulatory-compliance",
    path: "regulatory-compliance",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/regulatory-compliance.vue")
  },
  {
    name: "product-scaling-gmp-ai-through-existing-quality-systems",
    path: "scaling-gmp-ai-through-existing-quality-systems",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/scaling-gmp-ai-through-existing-quality-systems.vue")
  },
  {
    name: "product-sharepoint-governance",
    path: "sharepoint-governance",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/sharepoint-governance.vue")
  },
  {
    name: "product-systems-thinking-for-regulated-operations",
    path: "systems-thinking-for-regulated-operations",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/systems-thinking-for-regulated-operations.vue")
  },
  {
    name: "product-training",
    path: "training",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/training.vue")
  },
  {
    name: "product-validation-planning-for-sustainable-teams",
    path: "validation-planning-for-sustainable-teams",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/validation-planning-for-sustainable-teams.vue")
  },
  {
    name: "product",
    path: "",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/product/index.vue")
  }
]
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/products.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/services/index.vue")
  },
  {
    name: "solutions-and-capability",
    path: "/solutions-and-capability",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/solutions-and-capability.vue")
  },
  {
    name: "validate-quality-register",
    path: "/validate-quality-register",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/validate-quality-register.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/qx-lunarheart/qx-lunarheart/app/pages/index.vue")
  }
]